import { PDFDocumentData } from "@/src/components/pdf-viewer/types";

/**
 * Calculates the most visible PDF page within it's container element.
 * This is used to determine which page is selected when scrolling through
 * the PDF.
 *
 * TODO: If we want to be more efficient, we could start with the current page
 * and scan in the direction of the scroll.
 */
export function calculateMostVisiblePage(container: HTMLElement | null, documentData: PDFDocumentData[]) {
  if (!container) {
    return null;
  }

  const containerRect = container.getBoundingClientRect();
  let currentDocument: PDFDocumentData | null = null;
  let currentVisibleHeight = 0;

  for (const document of documentData) {
    const canvas = document.canvasRef.current;

    if (!canvas) continue;

    const canvasRect = canvas.getBoundingClientRect();

    if (canvasRect.bottom <= containerRect.top) continue;
    if (canvasRect.top >= containerRect.bottom) break;

    const visibleTop = Math.max(containerRect.top, canvasRect.top);
    const visibleBottom = Math.min(containerRect.bottom, canvasRect.bottom);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);

    if (visibleHeight > currentVisibleHeight) {
      currentVisibleHeight = visibleHeight;

      currentDocument = document;
    }
  }

  return currentDocument;
}
